import React, { Component } from 'react';
import {Header, Banner, About, Specilizing, Portfolio, Education, Footer} from '../layouts/home01/index';

class Home01 extends Component {
  
    render() {
        return (
            <div className="counter-scroll bg-home1 has-one-page">       
                <div id="mobile-menu-overlay"><span className="tf-close"></span></div>
                <Header />           
                <div id="content" className="content">
                    <div className="homepage-personal">
                        <Banner />
                        <div className="section slide-personal-Intro-second slide-dark">
                           
                        </div>
                        <div className="section slide-personal-Intro-second slide-dark bg-white">
                        
                            <section className="profile s1">
                                <div className="container" id="about">
                                    <About />
                                 
                                </div>
                            </section>
                        </div>
                        <Specilizing />
                    
                        <Portfolio/>
                    
                        <Education />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Home01;
